import BaseApi from '../base';

class TestApi extends BaseApi {
  /**
   * @param {string} token
   * @param {string} clientId
   * @returns {Promise<*>}
   */
  async getResults(token, clientId) {
    return this.makeRequest(this.METHOD_GET, `results?client=${clientId}`, token);
  }
}

export default TestApi;
